import {
    MapModelDefinitionToModel,
    MapModelDefinitionToProps
} from "@atlassiansox/bxp-content-framework";

import { models } from "../models";

export type Models = typeof models;

export type MapModelIdToModel<T extends keyof Models> =
    MapModelDefinitionToModel<Models, T>;

export type MapModelIdToProps<T extends keyof Models> =
    MapModelDefinitionToProps<Models, T>;

export type MapModelToProps<T> = {
    readonly model: T;
};
